import { motion } from "framer-motion";
import { Fuel, Droplets, Check } from "lucide-react";
import { REVEAL } from "@/lib/site";

const services = [
  {
    icon: Fuel,
    kicker: "Most common",
    title: "Petrol in a diesel car",
    text: "Petrol acts as a solvent in a diesel engine and can damage the fuel system. Don't start it — we fully drain and flush before any harm is done.",
    points: ["Full tank drain", "System flush", "Fresh fuel top-up"],
  },
  {
    icon: Droplets,
    kicker: "We fix it too",
    title: "Diesel in a petrol car",
    text: "Less common, but still a headache. Diesel clogs petrol injectors and fouls plugs. Our mobile unit clears it out and gets you running clean again.",
    points: ["Contaminant removal", "Injector-safe clean", "Back on the road"],
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="border-b border-black/10 bg-white py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5">
      <motion.div variants={REVEAL} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.4 }} className="mb-14 max-w-2xl">
        <span className="kicker text-[#1F7A6B]">What we rescue</span>
        <h2 className="mt-3 font-heading text-3xl md:text-5xl leading-tight text-[#171717]">
          Two mistakes we fix every day
        </h2>
      </motion.div>

      <div className="grid gap-6 md:grid-cols-2">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            variants={REVEAL}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            transition={{ delay: i * 0.1 }}
            className="rounded-2xl border border-black/10 bg-[#F5F3EF] p-8 shadow-soft-sm"
            data-testid={`service-card-${i + 1}`}
          >
            <span className="grid h-14 w-14 place-items-center rounded-xl bg-[#1F7A6B] text-white">
              <s.icon strokeWidth={2} className="h-6 w-6" />
            </span>
            <span className="mt-5 block kicker text-[#171717]/45">{s.kicker}</span>
            <h3 className="mt-1 font-heading text-2xl md:text-3xl text-[#171717]">{s.title}</h3>
            <p className="mt-3 leading-relaxed text-[#171717]/70">{s.text}</p>
            <ul className="mt-6 space-y-2.5">
              {s.points.map((p) => (
                <li key={p} className="flex items-center gap-2.5 font-medium text-[#171717]/80">
                  <span className="grid h-5 w-5 place-items-center rounded-full bg-[#E7DFCF] text-[#1F7A6B]">
                    <Check strokeWidth={3} className="h-3 w-3" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>

      <motion.div
        variants={REVEAL}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="mt-8 flex items-center justify-center"
      >
        <span
          data-testid="services-no-fee-badge"
          className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-[#22303C] px-5 py-2.5 text-sm font-semibold text-white"
        >
          <span className="h-2 w-2 rounded-full bg-[#1F7A6B]" /> No fix, no fee — every time
        </span>
      </motion.div>
    </div>
  </section>
);
